import { defineComponent as _defineComponent } from 'vue'
import { useAlternativeDeliveryFormJapan } from './alternative-delivery-form-japan.composable';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlternativeDeliveryFormB2CJapan',
  props: {
    model: null,
    yubinBangoLoaded: { type: Boolean },
    deliveryMethod: null,
    value: null
  },
  emits: ["input", "updateShippingCountry"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: ShippingAddress): void,
    (e: 'updateShippingCountry', value: AddressCountryViewObject): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    model: CheckoutPageViewModel,
    yubinBangoLoaded: boolean,
    deliveryMethod: DeliveryMethodViewObject,
    value?: ShippingAddress
 }

const phoneRegex = /^[+]{0,1}[- +0-9]*$/;





const alternativeDeliveryRegion = ref<HTMLInputElement>(null);
const alternativeDeliveryLocality = ref<HTMLInputElement>(null);

const states = computed(() => {
    if (!props.model.countryStates) {
        return [];
    }
    if (selectedShippingCountry.value.countryCode) {
        return props.model.countryStates.find(x => x.country === selectedShippingCountry.value.countryCode).states;
    }

    return props.model.countryStates.find(x => x.country === props.model.invoiceAddressCountries[0].id).states;
});


const {
    labelNamespace,
    selectedShippingCountry,
    selectedShippingState,
    form,
    onShippingStateChanged,
    blur,
    generalMaxLength,
    postalCodeLength,
    phoneNumberMaxLength
} = useAlternativeDeliveryFormJapan<ShippingAddress>(props, emit, { region: alternativeDeliveryRegion, locality: alternativeDeliveryLocality });

return { __sfc: true,phoneRegex, props, emit, alternativeDeliveryRegion, alternativeDeliveryLocality, states, labelNamespace, selectedShippingCountry, selectedShippingState, form, onShippingStateChanged, blur, generalMaxLength, postalCodeLength, phoneNumberMaxLength }
}

})